import { supabase } from '../../lib/supabase'
import { loadNationKits, NAT_TEAM_CODE } from '../../lib/nationKits'

// Anagrafica dei soli corridori indicati (id_rider) da dim_rider/dim_team: nome, nazionalita', maglia della squadra.
// La start list (view_start_list_display) esclude i ritirati e, per alcune gare, non esiste: con quella i corridori
// ritirati perdevano bandiera e maglia. Usata dalla tabella live del Pick e dalla scheda giocatore della Classifica.
export async function loadRiderInfo(ids, idRace = null) {
  const list = [...new Set(ids)].filter(Boolean)
  const riders = {}
  if (!list.length) return riders
  const { data: rd } = await supabase.from('dim_rider').select('id_rider, surname, name, id_national, id_team, avatar').in('id_rider', list)
  // dorsale della gara (solo se si passa idRace)
  const bibs = {}
  if (idRace) {
    const { data: sl } = await supabase.from('map_start_list').select('id_rider, bib').eq('id_race', idRace).in('id_rider', list)
    ;(sl ?? []).forEach(x => { bibs[x.id_rider] = x.bib })
  }
  const teamIds = [...new Set((rd ?? []).map(r => r.id_team).filter(Boolean))]
  const { data: tm } = teamIds.length ? await supabase.from('dim_team').select('id_team, uci_code, name, short_txt, kit').in('id_team', teamIds) : { data: [] }
  const teams = Object.fromEntries((tm ?? []).map(x => [x.id_team, x]))
  // squadra generica NAT: maglia e sigla del paese del corridore (se il paese ha il kit)
  const nations = (tm ?? []).some(x => x.uci_code === NAT_TEAM_CODE) ? await loadNationKits() : {}
  ;(rd ?? []).forEach(r => {
    const tt = teams[r.id_team]
    const nat = tt?.uci_code === NAT_TEAM_CODE ? nations[r.id_national] : null
    riders[r.id_rider] = {
      id: r.id_rider,
      label: `${r.surname} ${r.name}`,
      labelNew: `${r.surname} ${String(r.name ?? '').slice(0, 3)}.${tt?.uci_code ? ` [${tt.uci_code}]` : ''}`,
      id_national: r.id_national,
      kit: nat?.kit ?? tt?.kit ?? null,
      teamShort: nat?.kit ? nat.id_national_3 : (tt?.short_txt ?? null),
      teamName: nat?.kit ? nat.name : (tt?.name ?? null),
      avatar: r.avatar ?? null,
      bib: bibs[r.id_rider] ?? null,
    }
  })
  return riders
}
